<template>
  <ul class="list-day-event">
    <li
      v-for="(item, index) in timelineItems"
      :key="index"
      class="list-day-event__item m-b-4"
    >
      <div
        class="list-day-event"
        :class="[
          { info__item__holiday: item.event_type.toLowerCase() == 'holiday' },
          { info__item__event: item.event_type.toLowerCase() == 'event' },
          {
            info__item__exam_schedule:
              item.event_type.toLowerCase() == 'exam schedule'
          }
        ]"
      >
        <span v-if="item.start_date == item.end_date">{{
          getDay(item.start_date)
        }}</span>
        <span v-else
          >{{ getDay(item.start_date) }} - {{ getDay(item.end_date) }}</span
        >
      </div>
      <span class="list-day-event description">{{ item.description }}</span>
    </li>
  </ul>
</template>

<script>
import moment from 'moment'
export default {
  name: 'event-list',
  props: ['events'],
  data() {
    return {
      timelineItems: this.events
    }
  },
  computed: {
    hasItems() {
      return !!this.timelineItems.length
    }
  },
  methods: {
    getDay(date) {
      if (date) {
        return moment(date).format('DD')
      }
    }
  },
  watch: {
    events(events) {
      this.timelineItems = events
    }
  }
}
</script>

<style lang="scss" scoped>
.list-day-event {
  font-size: 12px;
  padding-left: 0;
  list-style: none;
  font-weight: 600;

  &__item {
    padding: 5px 6px;
    background-color: #fff;
    border-radius: 44px;
    -webkit-box-shadow: 0px 11px 10px -9px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 11px 10px -9px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 11px 10px -9px rgba(0, 0, 0, 0.25);
    display: flex;
  }
  &.info__item__holiday {
    width: 44px;
    height: 44px;
    border-radius: 44px;
    background-color: #ff5b57;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    line-height: 3.7;
  }

  &.info__item__event {
    width: 44px;
    height: 44px;
    border-radius: 44px;
    background-color: #00acac;
    color: #fff;
    text-align: center;
    line-height: 3.7;
  }

  &.info__item__exam_schedule {
    width: 44px;
    height: 44px;
    border-radius: 44px;
    background-color: #348fe2;
    color: #fff;
    text-align: center;
    line-height: 3.7;
  }
  &.description {
    line-height: 3.7;
    margin-left: 10px;
  }
}
</style>
